/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CountryStatistics } from './CountryStatistics';
import {
    CountryStatisticsFromJSON,
    CountryStatisticsFromJSONTyped,
    CountryStatisticsToJSON,
    CountryStatisticsToJSONTyped,
} from './CountryStatistics';
import type { PaymentStatistics } from './PaymentStatistics';
import {
    PaymentStatisticsFromJSON,
    PaymentStatisticsFromJSONTyped,
    PaymentStatisticsToJSON,
    PaymentStatisticsToJSONTyped,
} from './PaymentStatistics';
import type { ShippingStatistics } from './ShippingStatistics';
import {
    ShippingStatisticsFromJSON,
    ShippingStatisticsFromJSONTyped,
    ShippingStatisticsToJSON,
    ShippingStatisticsToJSONTyped,
} from './ShippingStatistics';

/**
 * 
 * @export
 * @interface CountryPaymentAndShippingStatistics
 */
export interface CountryPaymentAndShippingStatistics {
    /**
     * 
     * @type {Array<CountryStatistics>}
     * @memberof CountryPaymentAndShippingStatistics
     */
    countryStatistics?: Array<CountryStatistics>;
    /**
     * 
     * @type {Array<PaymentStatistics>}
     * @memberof CountryPaymentAndShippingStatistics
     */
    paymentStatistics?: Array<PaymentStatistics>;
    /**
     * 
     * @type {Array<ShippingStatistics>}
     * @memberof CountryPaymentAndShippingStatistics
     */
    shippingStatistics?: Array<ShippingStatistics>;
}

/**
 * Check if a given object implements the CountryPaymentAndShippingStatistics interface.
 */
export function instanceOfCountryPaymentAndShippingStatistics(value: object): value is CountryPaymentAndShippingStatistics {
    return true;
}

export function CountryPaymentAndShippingStatisticsFromJSON(json: any): CountryPaymentAndShippingStatistics {
    return CountryPaymentAndShippingStatisticsFromJSONTyped(json, false);
}

export function CountryPaymentAndShippingStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountryPaymentAndShippingStatistics {
    if (json == null) {
        return json;
    }
    return {
        
        'countryStatistics': json['countryStatistics'] == null ? undefined : ((json['countryStatistics'] as Array<any>).map(CountryStatisticsFromJSON)),
        'paymentStatistics': json['paymentStatistics'] == null ? undefined : ((json['paymentStatistics'] as Array<any>).map(PaymentStatisticsFromJSON)),
        'shippingStatistics': json['shippingStatistics'] == null ? undefined : ((json['shippingStatistics'] as Array<any>).map(ShippingStatisticsFromJSON)),
    };
}

export function CountryPaymentAndShippingStatisticsToJSON(json: any): CountryPaymentAndShippingStatistics {
    return CountryPaymentAndShippingStatisticsToJSONTyped(json, false);
}

export function CountryPaymentAndShippingStatisticsToJSONTyped(value?: CountryPaymentAndShippingStatistics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'countryStatistics': value['countryStatistics'] == null ? undefined : ((value['countryStatistics'] as Array<any>).map(CountryStatisticsToJSON)),
        'paymentStatistics': value['paymentStatistics'] == null ? undefined : ((value['paymentStatistics'] as Array<any>).map(PaymentStatisticsToJSON)),
        'shippingStatistics': value['shippingStatistics'] == null ? undefined : ((value['shippingStatistics'] as Array<any>).map(ShippingStatisticsToJSON)),
    };
}

